import * as React from 'react';
import { Header } from '../components/Header';
import { Button, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { Link, useNavigate } from 'react-router-dom';
import { Footer } from '../components/Footer';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
export default function ForgotPassword(props) {
  const { t } = useTranslation();
  const navigate = useNavigate(); 
  const [phoneNumber, setPhoneNumber] = React.useState('');  
  const [phoneNumberError, setPhoneNumberError] = React.useState('');
  const [show, setShow] = React.useState(false);
  const [result, setResult] = React.useState(true);

  const handleClose = () => {
    setShow(false);
    if(result){
      navigate('/', {replace: true });    
    }
  }

  const handleShow = () => setShow(true);

  const [dlgResultTitle, setDlgResultTitle] = React.useState('');
  const [dlgResultMessage, setDlgResultMessage] = React.useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    //Validate fields
    if(!phoneNumber){      
      setPhoneNumberError('Quý khách vui lòng nhập số điện thoại');
    }
    else{
      setPhoneNumberError('');      
      fetch("https://booking.bernard.vn/api/auth/forgotPassword", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          phoneNumber: phoneNumber          
        })
      })
      .then(r => {
        if(r.ok){
          setResult(true);
          setDlgResultTitle(t('forgot_password_result_success_title'));
          setDlgResultMessage(t('forgot_password_result_success_message'));
          handleShow();
        }
        else{
          setResult(false);
          setDlgResultTitle(t('forgot_password_result_fail_title'));
          setDlgResultMessage(t('forgot_password_result_fail_message'));
          handleShow();
        }
      })      
    }
  };

  return (
    
    <div className='page-fullscreen'>
      <Modal centered show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
              <Modal.Title>{dlgResultTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
                {dlgResultMessage}
            </Modal.Body>   
          <Modal.Footer>
              <Button variant="primary" onClick={handleClose}>
                  {t('close')}
              </Button>
          </Modal.Footer>
      </Modal>
      
      <Header />      
      <div className='page-content'>
        <Row style={{ height: 100 + '%', margin: 0 }}>
          <div className='col-lg-6 col-xs-12 blue-bg'>
            <div className='left-panel'>
              <div className='login-form vertical-center'>
                <div className='form-heading'>
                  <div className='title'>
                    {t('forgot_password')}
                  </div>
                  <div className='sub-title'>
                    {t('forgot_password_enter_phone')}
                  </div>
                </div>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mt-3">
                    <Form.Control name='phoneNumber' type="text" value={phoneNumber} placeholder={t('forgot_password_phone')} isInvalid={phoneNumberError !== ''} onChange={(e) => setPhoneNumber(e.target.value) } />
                      {phoneNumberError && (
                      <Form.Control.Feedback type="invalid">
                        {phoneNumberError}
                      </Form.Control.Feedback>
                      )}                    
                  </Form.Group>
                  <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row' }}>
                    <Button type='submit' className='submit' style={{ width: 100 + '%' }}>{t('reset_password')}</Button>
                  </Form.Group>
                  <Form.Group className='mt-3' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <Link to={'/signin'}>{t('have_account')}</Link>
                  </Form.Group>
                </Form>
              </div>
            </div>
          </div>
          <div className='right-panel col-lg-6 col-xs-12' style={{ backgroundImage: "url(/images/bg-1.png)", backgroundSize: 'cover' }}>
          </div>
        </Row>
      </div>
      <Footer />
    </div >
  );
}